<template>
  <div id="Index">

    <!-- 公告 -->
    <div class="Notice"  @click="jumpNotice" v-if="noticeShow || welcomeMsgFlag==1">
      <el-alert title="" type="warning" style="cursor: pointer;" :closable="false">
        <div class="importantNote notSelect">
          <img src="../assets/img/notice_icon.png" alt="" style="width: 20px;">
          <span v-if="noticeShow">{{notice.title| ellipsis}}<span style="margin-left: 16px;">（ {{notice.releaseTime.slice(0, 10)}} ）</span></span>
          <span v-else-if="welcomeMsgFlag==1">{{ welcomeContent }}</span>
        </div>
      </el-alert>
    </div>

    <!-- 批次选择 -->
    <div class="Plan"> 
      <p>
        <span class="notSelect">{{ currentPlan.name }}</span>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link notSelect">
            <span>切换</span> 
            <i class="el-icon-arrow-down"></i>
          </span>
          <template #dropdown>
            <el-dropdown-menu style="width: 360px; max-height:600px; height:auto; overflow-y:auto; overflow-x:auto; border-radius: 8px;">
              <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{ item.name }}</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </p>
    </div>

    <!-- Main -->
    <div class="Main" id="Main">
      <!-- 数据概览 -->
      <div class="Item">
        <div class="title">
          <div></div>
          <h2>数据概览</h2>
        </div>
        <div class="titleCard">
          <div :class="cardClass" v-for="(item, key) in cardInfo" :key="key" v-show="item.show">
            <div>
              <div>
                <h3>
                  <span>{{ item.name }}</span>
                </h3>
                <div style="display: flex; align-items: center;"> 
                  <span style="color: #2D2F33; font-weight: 700;">{{ item.num == 0 ? "-": item.num }}</span>
                  <span v-show="key == 3" style="font-size: 18px; color: #C2C6CC; margin: 0 18px 0 54px;">|</span>
                  <span v-show="key == 3" style="color: #2D2F33; font-weight: 700;">{{ item.num2 == 0 ? "-": item.num2 }}</span>
                </div>
              </div>
              <div class="icon"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 智能提醒 -->
      <div class="Item">
        <div class="title">
          <div></div>
          <h2>智能提醒</h2>
        </div>
        <div class="message" v-if="IntReminderIsShow">
          <p v-show=" IntReminderData.primaryEndAuditFlag != 0 ">您有 <span class="yellow">{{ IntReminderData.primaryEndAuditNum }}</span> 报名信息待初审，<span class="blue" @click="jumpAudit(1)">去审核</span></p>
          <p v-show=" IntReminderData.endAuditFlag != 0 ">您有 <span class="yellow">{{ IntReminderData.endAuditNum }}</span> 报名信息待{{planInfo.needAudit == 2 ? "终审": "审核"}}，<span class="blue" @click="jumpAudit(2)">去审核</span></p>
          <p v-show=" IntReminderData.expireDateFlag != 0 ">您的平台使用权限将于 <span class="yellow">{{ IntReminderData.expireDate }}</span> 到期，<span class="blue" @click="jumpAudit(3)">去查看</span></p>
        </div>
        <div class="message" v-else>
          <p class="notSelect" v-for="(item, index) in audit" :key="index" v-show="(item.flag == 1 && item.show) || ((auditStep == index + 1) && item.flag == 2 ) ">{{ item.message }} </p>
        </div>
      </div>

      <!-- 智能管理 -->
      <div class="Item" id="Intelligent_management">
        <div class="title">
          <div></div>
          <h2>智慧管理</h2>
        </div>
        <div class="Step">
          <el-steps direction="vertical" :active="auditStep">
            <el-step
              v-for="(item, index) in audit"
              :key="index"
              v-show="item.show"
              :class="item.flag == 1 ? 'start' : item.flag == 2 ? 'over' : ''"
              :id="'step_'+ index"
              :style="{'min-height': isOpenFlag ? '80px': '40px'}"
            >
              <template slot="description">

                <div class="top">
                  <div class="des" :class="isOpenFlag ? '': 'notOpenFlag'">
                    <div class="des-title notSelect">
                      <!-- scoreCheck -->
                      <span class="state" v-if="item.name != 'scoreCheck'"> <span class="dit" ></span>{{ item.flag == 1 ? "进行中": item.flag == 2 ? "已结束": "未开始" }}</span>
                      <span class="state" v-else> <span class="dit" ></span>{{ item.flag == 1 ? "已开始": item.flag == 2 ? "已结束": "未开始" }}</span>
                      <span class="name">{{ item.des_title }}</span>
                    </div>
                    <div class="des-data notSelect" :style="{'margin-top': isOpenFlag ? '8px': '0', 'text-align': isOpenFlag ? '': 'right'}">
                      <span>{{ item.des_data }}</span>
                    </div>
                  </div>
                </div>

                <el-collapse v-model="activeNames">
                  <el-collapse-item :name="index" :disabled="item.flag == 0"  v-if="isOpenFlag">

                    <template slot="title">
                      <div class="title-name">查看详情</div>
                    </template>
                    
                    <div class="StepInfo">
                      <!-- 报名 -->
                      <div class="Sign" v-if="item.name == 'Sign'">
                        <div class="info">
                          <div class="title">报名数据统计</div>
                          <div class="sign_number">
                            <div class="mobile_sign">
                              <span>移动端：</span>
                              <div class="number">
                                <div>
                                  <div>累计报名人数</div>
                                  <div>{{ signInfo[0] }}</div>
                                </div>
                                <div>
                                  <div>今日新增</div>
                                  <div>{{ signTrend.signNumOnMobileToday }}</div>
                                </div>
                                <div>
                                  <div>日同比</div>
                                  <div :style="{ color: signTrend.mobileSignDoD >= 0 ? '#FE5958':'#1DBF60' }">
                                    <i style="font-size: 12px;" :class=" signTrend.mobileSignDoD >= 0 ? 'el-icon-caret-top' :'el-icon-caret-bottom' "></i>
                                    <span style="font-size: 18px;">{{ Math.abs(signTrend.mobileSignDoD) }}%</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="pc_sign">
                              <span>PC端：</span>
                              <div class="number">
                                <div>
                                  <div>累计报名人数</div>
                                  <div>{{ signInfo[1] }}</div>
                                </div>
                                <div>
                                  <div>今日新增</div>
                                  <div>{{ signTrend.signNumOnWebToday }}</div>
                                </div>
                                <div>
                                  <div>日同比</div>
                                  <div :style="{ color: signTrend.webSignDoD >= 0 ? '#FE5958':'#1DBF60' }">
                                    <i style="font-size: 12px;" :class=" signTrend.webSignDoD >= 0 ? 'el-icon-caret-top' :'el-icon-caret-bottom' "></i>
                                    <span style="font-size: 18px;">{{ Math.abs(signTrend.webSignDoD) }}%</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="charts">
                          <div class="title">报名人次趋势图</div>
                          <div :id="'Chart_' + item.name" style="height: 430px;" :style="{ width: chart_Width + 'px' }"></div>
                        </div>
                      </div>
                      
                      <!-- 审核/缴费/准考证/阅卷 -->
                      <div class="primaryAudit" v-else-if="item.name == 'primaryAudit' || item.name == 'endAudit' || item.name == 'Pay' || item.name == 'Entrance' || item.name == 'marking' ">
                        <div class="left">
                          <div class="title">{{ item.title_left }}</div>
                          <div :id="item.name + '_Pie'" style="width: 560px; height: 420px;"></div>
                        </div>
                        <div class="right" style="position: relative;">
                          <div class="title">{{ item.title_right }}</div>
                          <p style="position: absolute; top: 12px; right: 32px;" v-if="item.name == 'primaryAudit'">累计审核：<span style="color: #00A652;">{{ totalAuditNum_primary }} 人次</span></p>
                          <p style="position: absolute; top: 12px; right: 32px;" v-else-if="item.name == 'endAudit'">累计审核：<span style="color: #00A652;">{{ totalAuditNum_audit }} 人次</span></p>
                          <p style="position: absolute; top: 12px; right: 32px;" v-else-if="item.name == 'Pay'">
                            已缴费：<span style="color: #00A652;">{{ payInfo.payNum }} </span>人，
                            共缴费：<span style="color: #00A652;">{{ "¥ " + payInfo.payMoney }} </span>元
                          </p>
                          <p style="position: absolute; top: 12px; right: 32px;" v-else-if="item.name == 'Entrance'">累计：<span style="color: #00A652;">{{ totalDownloadNum }} 人次</span> 下载</p>
                          <p style="position: absolute; top: 12px; right: 32px;" v-else-if="item.name == 'markingh'">累计评阅：<span style="color: #00A652;">{{ judgedCount }} </span> 份</p>
                          <div style="height: 420px;" :id="item.name + '_Bar'" :style="{ width: parseInt(chart_Width - 170) + 'px' }"></div>
                        </div>
                        
                      </div>

                      <!-- 考试 -->
                      <div class="Exam" v-else-if="item.name == 'Exam'">
                        <div class="top" v-if="examInfo.singleOrTotal == 1">当前场次 <span style="color: #00BF70;">{{examInfo.sessionNo}}</span> / {{examInfo.sessionCount}}，考试时间：{{examInfo.sessionExamBegin + ' ~ ' + examInfo.sessionExamEnd}}</div>
                        <div class="main">
                          <div class="left" style="position: relative;" v-show="needOIS">
                            <div class="currentTitle">
                              <p v-if="examInfo.singleOrTotal == 1">第 {{examInfo.sessionNo}} 场</p>
                              <p>签到数据</p>
                            </div>
                            <div id="Chart_Exam_A" style="height: 420px;" :style="{width: (chart_Width + 320 ) / 2 + 'px'}"></div>
                          </div>
                          <!-- margin: 0 auto; -->
                          <div  class="right" :class="needOIS ? '': 'needOIS'" style="position: relative;">
                            <div class="currentTitle">
                              <p v-if="examInfo.singleOrTotal == 1">第 {{examInfo.sessionNo}} 场</p>
                              <p>参考数据</p>
                            </div>
                            <div id="Chart_Exam_B" style="height: 420px;" :style="{width: (chart_Width + 320 ) / 2 + 'px'}"></div>
                          </div>
                        </div>
                      </div>

                      <!-- 成绩查询 -->
                      <div class="scoreCheck" v-else-if="item.name == 'scoreCheck'">

                        <div class="chooseCourse">
                          <span>科目：</span>
                          <el-select v-model="courseId" placeholder="请选择课程">
                            <el-option :label="item.courseName" :value="item.courseId" v-for="item in courseList" :key="item.id"></el-option>
                          </el-select>
                        </div>
                        <div class="title">考生成绩情况</div>
                        <div class="top">
                          <div>
                            <span>{{ scoreInfo.scoreMax }}</span> <span>分</span>
                            <br />
                            <span>最高分</span>
                          </div>
                          <div>
                            <span>{{ scoreInfo.scoreMin }}</span> <span>分</span>
                            <br />
                            <span>最低分</span>
                          </div>
                          <div>
                            <span>{{ scoreInfo.scoreAvg }}</span> <span>分</span>
                            <br />
                            <span>平均分</span>
                          </div>
                          <div>
                            <span>{{ scoreInfo.scorePass }}</span> <span></span>
                            <br />
                            <span>及格率</span>
                          </div>
                          <div>
                            <span>{{ scoreInfo.scoreExcellent }}</span> <span></span>
                            <br />
                            <span>优秀率</span>
                          </div>
                        </div>

                        <div class="bottom">
                          <div v-for="(item, index) in scoreInfo.dateMapList" :key="index">
                            <span>{{ item.key }}</span>
                            <div style="display: flex; justify: left;">
                              <div :style="itemObject(item, index)"> 
                                <span 
                                  style="margin-left: 16px; color: #FFF; float: right; margin-right: 16px;" 
                                  v-if="((item.value/scoreInfo.examedCount).toFixed(2) * 100) > 15"
                                >
                                  {{ item.value }}人   {{ (item.value/scoreInfo.examedCount).toFixed(2) * 100 }}%
                                </span> 
                              </div>
                              <span 
                                style="margin-left: 16px;" 
                                v-if="((item.value/scoreInfo.examedCount).toFixed(2) * 100) <= 15"
                              >
                                {{ item.value }}人   {{ (item.value/scoreInfo.examedCount).toFixed(2) * 100 }}%
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </el-collapse-item>
                </el-collapse>
              </template> 
            </el-step>
          </el-steps>
        </div>
      </div>

    </div>

    <!-- 跳转考试报告按钮 -->
    <div class="exportPDF" v-show="isShowPDF">
      <p>我们为您生成了完整的报告，请 <span @click="jumpExportPDF">前往查看</span></p>
    </div>
    
    <!-- 租户到期提示弹窗 -->
    <ots-custom-dialog :dialog.sync="BeComing_Dialog" title="感谢你使用弘成慧考平台" width="40%">
      <template v-slot:content>
        <div style="font-family: 'PingFangSC-Medium, PingFang SC'; line-height: 24px; font-size: 16px;">
          <p> 您的平台使用权限将于<span style="color: #006AFF;"> {{ IntReminderData.expireDate }} </span> 到期！ </p>
          <p> 到期后部分功能将停止使用。为了避免给您的考务工作带来影响，请尽快联系销售或客服人员。 </p>
        </div>
      </template>
      <template v-slot:footer>
        <div style="width: 100%; text-align: center;">
          <el-button round type="primary" @click="BeComing_Dialog = false">知道了</el-button>
        </div>
      </template>
    </ots-custom-dialog>

    <!-- 公告列表弹窗 -->
    <ots-custom-dialog :dialog.sync="noticeDialog" :title="notice.title + '（' + notice.releaseTime + '）'" width="50%">
      <template v-slot:content>
        <div style="font-family: 'PingFangSC-Medium, PingFang SC'; line-height: 24px; font-size: 16px;">
          <div v-html="notice.content"></div>
        </div>
      </template>
      <template v-slot:footer>
        <div style="width: 100%; text-align: center;">
          <el-button round type="primary" @click="noticeDialog = false">知道了</el-button>
        </div>
      </template>
    </ots-custom-dialog>

    <!-- 单次公告弹窗 -->
    <ots-custom-dialog :dialog.sync="noticeOnceDialog" :title="alertInfo.title + '（' + alertInfo.releaseTime + '）'" width="50%">
      <template v-slot:content>
        <div style="font-family: 'PingFangSC-Medium, PingFang SC'; line-height: 24px; font-size: 16px;">
          <div v-html="alertInfo.content"></div>
        </div>
      </template>
      <template v-slot:footer>
        <div style="width: 100%; text-align: center;">
          <el-button round type="primary" @click="noticeOnceDialog = false">知道了</el-button>
        </div>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import {
  getSmartReminderApi,
  getSignNumberFn, 
  getHomePagePlanListApi, 
  getExamCountApi, 
  getSignDoDApi, 
  getSignDateCountApi, 
  getAuditCountApi, 
  getAuditDateCountApi, 
  getPayCountApi,
  getPayDateCountApi,
  getDownloadEntranceCountApi,
  getDownloadEntranceDateCountApi,
  getJudgeCountApi,
  getScoreCountApi
} from "@/http/modules/home";
import vueSeamlessScroll from "vue-seamless-scroll";
import isHasRoute from "@/help/isHasRoute";
import { mapMutations } from "vuex";
import { selectNoticeListInfo, selectNoticeByIdInfo } from "@/http/modules/student/notice";
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      // 智慧管理，展开步骤
      activeNames: [],
      // 批次列表
      planList: [],
      // 当前批次信息（根据ID查询）
      planInfo: {},
      // 当前批次信息（根据查询列表查询）
      currentPlan: {},
      // 卡片信息
      cardInfo: [
        {
          name: "报名人数",
          num: 0,
          show: true,
        },
        {
          name: "审核通过人数",
          num: 0,
          show: true,
        },
        {
          name: "已缴费人数",
          num: 0,
          show: true,
        },
        {
          name: "参加考试人数 / 人次",
          num: 0,
          num2: 0,
          show: true,
        }
      ],
      // 当前进行中 Step
      auditStep: 0,
      // Step 配置数据
      audit: [
        {
          step: 1,
          des_title: "报名",
          des_data: "报名起止时间：",
          show: true,
          flag: 0,
          name: "Sign",
          message: "当前考试批次报名进行中，请您关注！",
        },
        {
          step: 2,
          des_title: "报名资格审核（初审）",
          des_data: "初审起止时间：",
          show: true,
          flag: 0,
          name: "primaryAudit",
          message: "当前报名初审进行中，请您关注！",
          title_left: "初审数据统计",
          title_right: "初审工作量分布图",
        },
        {
          step: 3,
          des_title: "报名资格审核（终审）",
          des_data: "终审起止时间：",
          show: true,
          flag: 0,
          name: "endAudit",
          message: "当前报名终审进行中，请您关注！",
          title_left: "审核数据统计",
          title_right: "审核工作量分布图",
        },
        {
          step: 4,
          des_title: "缴费",
          des_data: "缴费起止时间：",
          show: true,
          flag: 0,
          name: "Pay",
          message: "当前考生缴费中，请您关注！",
          title_left: "缴费数据统计",
          title_right: "缴费人次分布",
        },
        {
          step: 5,
          des_title: "打印准考证",
          des_data: "打印起止时间：",
          show: true,
          flag: 0,
          name: "Entrance",
          message: "当前准考证打印中，请您关注！",
          title_left: "准考证下载情况统计",
          title_right: "准考证下载分布",
        },
        {
          step: 6,
          des_title: "考试",
          des_data: "考试计划时间：",
          show: true,
          flag: 0,
          name: "Exam",
          message: "当前考试进行中，请您关注！",
          title_left: "累计签到数据统计",
          title_right: "累计参考数据统计",
        },
        {
          step: 7,
          des_title: "阅卷",
          des_data: "阅卷起止时间：",
          show: true,
          flag: 0,
          name: "marking",
          message: "当前教师评阅进行中，请您关注！",
          title_left: "阅卷统计",
          title_right: "阅卷分布图",
        },
        {
          step: 8,
          des_title: "成绩查询",
          des_data: "查询开始时间：",
          show: true,
          flag: 0,
          name: "scoreCheck",
          message: "当前成绩已发布，请您关注！"
        },
      ],
      // 报名数据统计
      signTrend: {
        "signNumOnWebToday": 0,
        "signNumOnMobileToday": 0,
        "signNumOnWebBefore": 0,
        "signNumOnMobileBefore": 0,
        "webSignDoD": 0,
        "mobileSignDoD": 0
      },
      // 累计初审
      totalAuditNum_primary: 0,
      // 累计终审
      totalAuditNum_audit: 0,
      // 考试场次数据
      examInfo: {
        singleOrTotal: "",
        sessionNo: "",
        sessionCount: "",
        sessionExamBegin: "",
        sessionExamEnd: "",
      },
      // 成绩 -- 课程列表
      courseList: [],
      // 成绩 -- 选中课程时
      courseId: "",
      // 智能提醒
      IntReminderData: {},
      IntReminderIsShow: false,
      // 成绩
      scoreInfo: {},
      // 缴费默认值
      payInfo: {
        payNum: 0,
        payMoney: 0,
      },
      // 已评阅累计数量
      judgedCount: 0,
      // 准考证累计下载
      totalDownloadNum: 0,
      BeComing_Dialog: false,
      // 是否开启智慧管理
      isOpenFlag: false,
      signInfo: [],
      myChart_Sign: "",
      chart_Width: "",
      noticeShow: "",
      welcomeMsgFlag: 0,
      welcomeContent: '',
      notice: "",
      // 是否展示 智慧管理 => 考试 => 第一个环形图
      needOIS: true,
      // 列表公告 -- 弹窗开关
      noticeDialog: false,
      // 弹窗公告 -- 弹窗开关
      noticeOnceDialog: false,
      // 弹窗公告 -- 数据
      alertInfo: {},
      // 跳转PDF
      isShowPDF: false
    }
  },
  watch: {
    currentPlan: "resetInfo",
    courseId: "resetScoreStep"
  },
  filters: {
    ellipsis: function (value) {
      if (!value) return "";
      if (value.length > 20) return value.slice(0, 20) + '...';
      return value;
    }
  },
  computed: {
    /**********************************************
     * @param { 成绩查询流程 => 颜色 && 比例 }
     **********************************************/
    itemObject(item, index) {
      const scoreColorList = [
        "linear-gradient(90deg, #F23D00 0%, #FC5F11 100%)",
        "linear-gradient(90deg, #F27900 0%, #F29718 100%)",
        "linear-gradient(90deg, #10D9A7 0%, #00BF70 100%)",
        "linear-gradient(90deg, #17C1F0 0%, #0088EA 99%)",
        "linear-gradient(90deg, #459CFF 0%, #1274FE 99%)",
        "linear-gradient(90deg, #7E7EFB 0%, #4322E5 100%)",
      ];
      return (item, index) => ({
        background: scoreColorList[index],
        width: item.value == 0 ? 0 : item.value / this.scoreInfo.examedCount * 100 + "%",
      })
    },

    /**********************************************
     * @param { 数据概览 => 卡片大小 }
     **********************************************/
    cardClass() {
      return `titleCardItem ${this.planInfo.isPay == 1 ? "titleCardItemWidth_25" : "titleCardItemWidth_33"}`;
    },

    /**********************************************
     * @param { 实时播报 => 滚动配置 }
     **********************************************/
    classOption() {
      return {
        step: 1,
        waitTime: 1000,
        hoverStop: false,
        limitMoveNum: 6,
        openWatch: true,
      }
    },

    /**********************************************
     * @param { 获取路由数据 }
     **********************************************/
    routes() {
      return this.$store.getters.showRoutes;
    },
  },

  mounted() {
    // 菜单收放 => 配置不同 E-charts 宽度 => 避免因页面DOM变动导致图表过大/过小
    let collapse = window.localStorage.getItem("collapse");
    if (collapse === "false") {
      this.chart_Width = document.body.clientWidth - 620;
    } else {
      this.chart_Width = document.body.clientWidth - 730;
    }
    this.initData();
    this.getNotice();
    this.getNoticeOnce();
    this.getCustomWelcome();
  },
  methods: {
    ...mapMutations("currentPlan", ["setCurrentPlan"]),

    /**********************************************
     * @param { 获取批次列表 & 默认选中第一个 }
     **********************************************/
    async initData() {
      const { data } = await getHomePagePlanListApi();
      this.planList = data;
      this.currentPlan = data[0];
    },

    /**********************************************
     * @param { 批次切换 => 更换当前批次数据 }
     **********************************************/
    changPlan(value) {
      this.currentPlan = value;
    },

    /**********************************************
     * @param { 批次切换 => 变动相关数据 }
     **********************************************/
    async resetInfo() {
      // (1) 数据概览
      await this.getCardInfo();
      // (2) 当前批次信息
      await this.getPlanInfo();
      // (3) 当前批次课程列表
      await this.getCourseList();
      // (4) 智能提醒
      await this.IntReminder();
      // (5) 自动打开当前流程
      await this.openStep();
      // (6) 手动执行成绩查询, 避免批次更新, 课程不变, 导致无数据
      await this.resetScoreStep(this.courseList[0].courseId)
      // (7) 页面更新时定位
      // await this.setScrollTarget();
      // (8) 是否展示"考试报告"按钮
      // await this.isCanGoPDF();
    }, 

    /**********************************************
     * @param { 智能提醒：（接口获取） }
     **********************************************/
    async IntReminder() {
      const { data } = await getSmartReminderApi({planId: this.currentPlan.id});
      this.IntReminderData = data;
      this.IntReminderIsShow = data.primaryEndAuditFlag > 0 || data.endAuditFlag > 0 || data.expireDateFlag > 0;
    },

    /**********************************************
     * @param { 当前批次所属课程列表 }
     **********************************************/
    async getCourseList() {
      const { data: courseList } = await this.$api.applyManage.getPlanCourse({ planId: this.currentPlan.id });
      // if (courseList.length > 5) {
      //   let item = {
      //     courseId : "moreCourse",
      //     courseName : "更多" 
      //   }
      //   this.courseList = [...courseList.slice(0, 5), item];
      // } else {
      //   this.courseList = courseList;
      // }
      this.courseList = courseList;
      this.courseId = courseList[0].courseId;
    },

    /**********************************************
     * @param { 数据概览 }
     **********************************************/
    async getCardInfo() {
      const { data } = await getSignNumberFn({ planId: this.currentPlan.id });
      for(let Key in data) {
        data[Key] = data[Key] ? data[Key] : 0;
      }
      this.isShowPDF = data.examReportShowFlag == 1 ? true: false;
      this.signInfo = [data.mobileSignNum, data.webSignNum];
      this.cardInfo[0].num = data.signNum;
      this.cardInfo[1].num = data.passNum;
      this.cardInfo[2].num = data.payNum;
      this.cardInfo[3].num = data.examNum;
      this.cardInfo[3].num2 = data.examCourseNum;
    },

    /**********************************************
     * @param { 获取当前批次信息 }
     * 重置 Step
     * 重置 E-charts
     **********************************************/
    async getPlanInfo() {
      const { data: planInfo } = await this.$api.applyManage.getCurrentPlan({ planId: this.currentPlan.id });
      this.planInfo = planInfo ? planInfo : {};
      // 为 null 的数据 ==> 变为 ""
      for (let key in this.planInfo) {
        this.planInfo[key] = this.planInfo[key] ? this.planInfo[key] : '';
      }
      // 数据概览 ==> 是否展示 "缴费" 卡片
      this.cardInfo[2].show = planInfo.isPay == 1 ? true : false;
      // Step
      await this.setStepInfo();
      // E-charts
      await this.drowEcharts();
    },

    /**********************************************
     * @param { 重置 Step }
     **********************************************/
    async setStepInfo() {
      this.audit[0].des_data = `报名起止时间：${this.planInfo.beginSign} ~ ${this.planInfo.endSign}`;
      this.audit[1].des_data = `初审截止时间：${this.planInfo.primaryEndAudit}`;
      this.audit[2].des_data = `终审截止时间：${this.planInfo.endAudit}`;
      this.audit[3].des_data = `缴费起止时间：${this.planInfo.startPay} ~ ${this.planInfo.endPay}`;
      this.audit[4].des_data = `打印起止时间：${this.planInfo.beginEntrance} ~ ${this.planInfo.endExam}`;
      this.audit[5].des_data = `考试计划时间：${this.planInfo.beginExam} ~ ${this.planInfo.endExam}`;
      this.audit[6].des_data = `阅卷起止时间：${this.planInfo.teacherReviewBeginTime} ~ ${this.planInfo.teacherReviewEndTime}`;
      this.audit[7].des_data = `查询开始时间：${this.planInfo.beginScoreCheck}`;

      let currentTime = new Date().getTime();
      // let beginSign = new Date(this.planInfo.beginSign).getTime();
      let beginSign = new Date(this.planInfo.beginSign.replace(/\-/g, "/")).getTime();
      // let endSign = new Date(this.planInfo.endSign).getTime();
      let endSign = new Date(this.planInfo.endSign.replace(/\-/g, "/")).getTime();
      // let primaryEndAudit = new Date(this.planInfo.primaryEndAudit).getTime();
      let primaryEndAudit = new Date(this.planInfo.primaryEndAudit.replace(/\-/g, "/")).getTime();
      // let endAudit = new Date(this.planInfo.endAudit).getTime();
      let endAudit = new Date(this.planInfo.endAudit.replace(/\-/g, "/")).getTime();
      // let startPay = new Date(this.planInfo.startPay).getTime();
      let startPay = new Date(this.planInfo.startPay.replace(/\-/g, "/")).getTime();
      // let endPay = new Date(this.planInfo.endPay).getTime();
      let endPay = new Date(this.planInfo.endPay.replace(/\-/g, "/")).getTime();
      // let beginEntrance = new Date(this.planInfo.beginEntrance).getTime();
      let beginEntrance = new Date(this.planInfo.beginEntrance.replace(/\-/g, "/")).getTime();
      // let beginExam = new Date(this.planInfo.beginExam).getTime();
      let beginExam = new Date(this.planInfo.beginExam.replace(/\-/g, "/")).getTime();
      // let endExam = new Date(this.planInfo.endExam).getTime();
      let endExam = new Date(this.planInfo.endExam.replace(/\-/g, "/")).getTime();
      // let beginScoreCheck = new Date(this.planInfo.beginScoreCheck).getTime();
      let beginScoreCheck = new Date(this.planInfo.beginScoreCheck.replace(/\-/g, "/")).getTime();
      // let teacherReviewBeginTime = new Date(this.planInfo.teacherReviewBeginTime).getTime();
      let teacherReviewBeginTime = new Date(this.planInfo.teacherReviewBeginTime.replace(/\-/g, "/")).getTime();
      // let teacherReviewEndTime = new Date(this.planInfo.teacherReviewEndTime).getTime();
      let teacherReviewEndTime = new Date(this.planInfo.teacherReviewEndTime.replace(/\-/g, "/")).getTime();

      // 报名
      this.audit[0].flag = currentTime < beginSign ? 0 : (currentTime >= beginSign && currentTime < endSign ? 1 : 2);
      // 初审
      this.audit[1].flag = currentTime < beginSign ? 0 : (currentTime >= beginSign && currentTime < primaryEndAudit ? 1 : 2);
      this.audit[1].show = this.planInfo.needAudit == 2;
      // 终审
      this.audit[2].flag = currentTime < beginSign ? 0 : (currentTime >= beginSign && currentTime < endAudit ? 1 : 2);
      this.audit[2].show = this.planInfo.needAudit == 1 || this.planInfo.needAudit == 2;
      this.audit[2].des_title = this.planInfo.needAudit == 1 ? '报名资格审核' : '报名资格审核（终审）';
      this.audit[2].message = this.planInfo.needAudit == 1 ? "当前报名审核进行中，请您关注！" : "当前报名终审进行中，请您关注！";
      this.audit[2].title_left = this.planInfo.needAudit == 1 ? "审核数据统计" : "终审数据统计";
      this.audit[2].title_right = this.planInfo.needAudit == 1 ? "审核工作量分布图" : "终审工作量分布图";
      // 缴费
      this.audit[3].flag = currentTime < startPay ? 0 : (currentTime >= startPay && currentTime < endPay ? 1 : 2);
      this.audit[3].show = this.planInfo.isPay == 1;
      // 准考证
      this.audit[4].flag = currentTime < beginEntrance ? 0 : (currentTime >= beginEntrance && currentTime < beginExam ? 1 : 2);
      this.audit[4].show = this.planInfo.downloadEntrance == 1;
      // 考试
      this.audit[5].flag = currentTime < beginExam ? 0 : (currentTime >= beginExam && currentTime < endExam ? 1 : 2);
      // 阅卷
      this.audit[6].flag = currentTime < teacherReviewBeginTime ? 0 : (currentTime >= teacherReviewBeginTime && currentTime < teacherReviewEndTime ? 1 : 2);
      this.audit[6].show = this.planInfo.teacherReviewBeginTime && this.planInfo.teacherReviewEndTime;
      // 成绩
      this.audit[7].flag = currentTime < beginScoreCheck ? 0 : (currentTime >= beginScoreCheck ? 1 : 2);

      if (currentTime > beginScoreCheck) {
        this.auditStep = 8;
        return;
      } else if (currentTime > teacherReviewBeginTime && this.planInfo.teacherReviewBeginTime && this.planInfo.teacherReviewEndTime) {
        this.auditStep = 7;
        this.audit[6].message = this.audit[6].flag == 1 ? "当前阅卷进行中，请您关注！" : "当前阅卷已结束，请您关注！";
        return;
      } else if (currentTime > beginExam) {
        this.auditStep = 6;
        this.audit[5].message = this.audit[5].flag == 1 ? "当前考试进行中，请您关注！" : "当前考试已结束，请您关注！";
        return;
      } else if (currentTime > beginEntrance && this.planInfo.downloadEntrance == 1) {
        this.auditStep = 5;
        this.audit[4].message = this.audit[4].flag == 1 ? "当前准考证打印中，请您关注！" : "准考证打印已结束，请您关注！";
        return;
      } else if (currentTime > startPay && this.planInfo.isPay == 1) {
        this.auditStep = 4;
        this.audit[3].message = this.audit[3].flag == 1 ? "当前考生缴费中，请您关注！" : "考生缴费已结束，请您关注！";
        return;
      } else if ((this.planInfo.needAudit == 1 || this.planInfo.needAudit == 2) && currentTime > beginSign) {
        this.auditStep = 3;
        this.audit[2].message = this.audit[2].flag == 1 ? `当前报名${ this.planInfo.needAudit == 2 ? "终审": "审核" }进行中，请您关注！` : `当前报名${ this.planInfo.needAudit == 2 ? "终审": "审核" }已结束，请您关注！`;
        return;
      } else if ((this.planInfo.needAudit == 1 || this.planInfo.needAudit == 2) && currentTime > beginSign) {
        this.auditStep = 2;
        this.audit[1].message = this.audit[1].flag == 1 ? "当前报名初审进行中，请您关注！" : "当前报名初审已结束，请您关注！";
        return;
      } else if(currentTime > beginSign) {
        this.auditStep = 1;
        this.audit[0].message = this.audit[0].flag == 1 ? "当前考试批次报名进行中，请您关注！" : "当前考试批次报名已结束，请您关注！";
        return;
      }
    },

    /**********************************************
     * @param { 重置 E-charts 数据 + 绘制 }
     **********************************************/
    async drowEcharts() {
      // 智慧管理 ==> 总开关
      let { data: config } = await this.$api.system.getConfigData();
      let isOpenFlag = false;
      config.configList.map(e=>{
        if (e.setName == "defaultPageDetailShowFlag") {
          isOpenFlag = e.setValue == 1 ? true : false;
        }
        this.needOIS = false;
      })

      this.isOpenFlag = isOpenFlag;

      if (isOpenFlag) {
        // E-charts 数据处理
        let planId = this.currentPlan.id
        this.$nextTick(async () => {
          
          // (1) 报名
          if (this.audit[0].show && this.audit[0].flag != 0) {
            // 报名数据统计
            const { data } = await getSignDoDApi({planId});
            this.signTrend = data;
            // 报名人次趋势图
            const {data: signInfo} = await getSignDateCountApi({planId})
            this.signChart(signInfo);
          }

          // (2) 初审
          if (this.audit[1].show && this.audit[1].flag != 0) {
            // 审核数据统计
            const { data } = await getAuditCountApi({ planId, isAudit: 1 });
            let primaryAudit = [
              { value: data.unAuditNum, name: '待审核' },
              { value: data.auditPassNum, name: '审核通过' },
              { value: data.auditNoPassNum, name: '未通过' },
            ]
            // 判断初审是否结束
            if (this.audit[1].flag == 2) {
              primaryAudit = [
                { value: data.auditPassNum, name: '审核通过' },
                { value: data.auditNoPassNum, name: '未通过' },
              ]
            }
            this.totalAuditNum_primary = data.totalAuditNum;
            this.set_Chart_Pie(primaryAudit, 'primaryAudit_Pie', false);

            // 审核工作量分布图
            const { data: primaryAuditInfo, code } = await getAuditDateCountApi({ planId, isAudit: 1 });
            if (code != 1) return;
            let data_x = [];
            let data_y = [];
            primaryAuditInfo.map(e=>{
              data_x.push(e.timeStr);
              data_y.push(e.num);
            })
            this.set_Chart_Bar("primaryAudit_Bar", data_x, data_y);
          }

          // (3) 终审
          if (this.audit[2].show && this.audit[2].flag != 0) {
              const { data } = await getAuditCountApi({ planId, isAudit: 2 });
              let primaryAudit = [
                { value: data.unAuditNum, name: '待审核' },
                { value: data.auditPassNum, name: '审核通过' },
                { value: data.auditNoPassNum, name: '未通过' },
              ]

              // 终审是否结束
              if (this.audit[2].flag == 2) {
                primaryAudit = [
                  { value: data.auditPassNum, name: '审核通过' },
                  { value: data.auditNoPassNum, name: '未通过' },
                ]
              }

              this.totalAuditNum_audit = data.totalAuditNum;
              this.set_Chart_Pie(primaryAudit, 'endAudit_Pie', false);

              // 审核工作量分布图
              const { data: primaryAuditInfo, code } = await getAuditDateCountApi({ planId, isAudit: 2 });
              if (code != 1) return;
              let data_x = [];
              let data_y = [];
              primaryAuditInfo.map(e=>{
                data_x.push(e.timeStr);
                data_y.push(e.num);
              })
              this.set_Chart_Bar("endAudit_Bar", data_x, data_y);
          }

          // (3) 缴费
          if (this.audit[3].show && this.audit[3].flag != 0) {
            // 缴费数据统计
            const { data } = await getPayCountApi({ planId });
            this.payInfo = data;

            let payData = [
              { value: data.payNum, name: '已缴费' },
              { value: data.refundNum, name: '退费' },
              { value: data.unPayNum, name: '未缴费' },
            ]
            this.set_Chart_Pie(payData, 'Pay_Pie', false);
            // 缴费人次分布图
            const { data: payInfo, code } = await getPayDateCountApi({ planId });
            if (code != 1) return;
            let data_x = [];
            let data_y = [];
            payInfo.map(e=>{
              data_x.push(e.timeStr);
              data_y.push(e.num);
            })         
            this.set_Chart_Bar("Pay_Bar", data_x, data_y);
          }

          // (4) 准考证
          if (this.audit[4].show && this.audit[4].flag != 0) {
            // 准考证下载情况统计
            const { data } = await getDownloadEntranceCountApi({ planId });
            this.totalDownloadNum = data.totalDownloadNum;
            let Entrance = [
              { value: data.downloadNum, name: '已下载' },
              { value: data.unDownloadNum, name: '未下载' },
            ]
            this.set_Chart_Pie(Entrance, 'Entrance_Pie', false);
            // 准考证下载分布
            const { data: EntranceInfo, code } = await getDownloadEntranceDateCountApi({ planId });
            if (code != 1) return;
            let data_x = [];
            let data_y = [];
            EntranceInfo.map(e=>{
              data_x.push(e.timeStr);
              data_y.push(e.num);
            })   
            this.set_Chart_Bar("Entrance_Bar", data_x, data_y);
          }

          // (5) 考试
          if (this.audit[5].show && this.audit[5].flag != 0) {
            const { data } = await getExamCountApi({ planId });
            // 当前场次配置
            this.examInfo = {
              singleOrTotal: data.singleOrTotal,
              sessionNo: data.sessionNo,
              sessionCount: data.sessionCount,
              sessionExamBegin: data.sessionExamBegin,
              sessionExamEnd: data.sessionExamEnd,
            }
            // 累计签到数据统计
            let examSignInfo = [
              { value: data.signPassedCount , name: '签到通过' },
              { value: data.signUnPassCount, name: '签到未通过' },
              { value: data.signUnSignCount, name: '未签到' },
            ]
            this.set_Chart_Pie(examSignInfo, 'Chart_Exam_A', false);
            // 累计参考数据统计
            let examAllInfo = [
              { value: data.examExamedCount , name: '实考人次' },
              { value: data.examUnExamCount, name: '缺考人次' },
            ]
            this.set_Chart_Pie(examAllInfo, 'Chart_Exam_B', false);
          }

          // (6) 阅卷
          if (this.audit[6].show && this.audit[6].flag != 0) {
            const { data } = await getJudgeCountApi({ planId });
            this.judgedCount = data.judgedCount;
            // 阅卷统计
            let judgePie = [
              { value: data.judgedCount , name: '已评阅' },
              { value: data.unjudgeCount, name: '未评阅' },
            ]
            this.set_Chart_Pie(judgePie, 'marking_Pie', false);
            // 阅卷分布图
            let data_x = [];
            let data_y = [];
            data.dateMapList.map(e=>{
              data_x.push(e.key);
              data_y.push(e.value);
            })   
            this.set_Chart_Bar("marking_Bar", data_x, data_y);
          }
        })
      } else {
        return false;
      }
    },
    /**********************************************
     * @param { 成绩流程（特殊）==> 需额外根据课程查询 }
     **********************************************/
    async resetScoreStep(courseId) {
      // if (courseId == "moreCourse") {
      //   this.$router.push({ name: "scoreAnalysis", query: { planId: this.currentPlan.id } });
      //   return;
      // }
      /* 
        
      */
      if (this.isOpenFlag) {
        if (this.audit[7].flag != 0) {
          let params = {
            planId: this.currentPlan.id,
            courseId
          }
          const { data } = await getScoreCountApi(params);
          this.scoreInfo = data;
        }
      };
    },

    /**********************************************
     * @param { 报名用 E-charts }
     **********************************************/
    signChart(signInfo) {
      let data_x = [];
      let data_y = [];
      signInfo.map(e=>{
        data_x.push(e.timeStr);
        data_y.push(e.num);
      })
      this.$nextTick(() => {
        this.myChart_Sign = this.$echarts.init(document.getElementById("Chart_Sign"));
        let option = {
          // 鼠标悬浮描述
          tooltip: {
            trigger: "item",
            formatter: function(params) {
              var result = '';
              result += '日期：' + params.name + '<br/>';
              result += '人数：' + params.value + '<br/>';
              return result;
            },
            textStyle: {
              color: '#737780',
              fontSize: 14,
            },
            borderColor: '#E1E6ED',
            fontFamily: "PingFangSC-Regular, PingFang SC",
          },
          // 图表上下左右间距
          grid: {
            x: 32,
            x2: 48,
            y2: 36,
          },
          // 横坐标
          xAxis: {
            type: 'category',
            data: data_x
          },
          // 纵坐标
          yAxis: {
            name: "单位：人次",
            type: 'value',
            nameTextStyle: {
              color: "#9299A6",
              fontFamily: "PingFangSC-Regular, PingFang SC",
              padding: [0, 0, 16, 0]
            },
          },
          series: [
            {
              data: data_y,
              type: 'line',
              label: {
                show: true,
                color: "#636871",
                fontSize: 12,
                fontFamily: "PingFangSC-Regular, PingFang SC",
              },
              itemStyle: {
                normal: {
                  color: "#265BFF",
                  lineStyle: {
                    color: "#265BFF"
                  },
                }
              },
              areaStyle: {
                normal: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 1,
                        color: 'rgba(233, 238, 255, 0)'
                      },
                      {
                        offset: 0,
                        color: 'rgba(118, 152, 255, 0.4666)'
                      },
                    ],
                    global: false
                  }
                }
              }
            }
          ]
        };
        this.myChart_Sign.setOption(option, true);
      })

    },

    /**********************************************
     * @param { E-charts Pie }
     * @data 数据
     * @key ID
     * @label true: 中心文字  false: 导线文字
     * @colorNum 颜色组
     **********************************************/
    set_Chart_Pie(data, key, label, colorNum) {
      // 是否展示导线
      let isShowLine = true;
      // 是否环状图
      let isRadius = true;

      // 是否为环形图
      if (key == "primaryAudit_Pie" || key == "endAudit_Pie" || key == "Pay_Pie") {
        isRadius = false;
      }

      // 色组
      var colorList = [
        {c1: '#EBEDF2', c2: '#EBEDF2'}, // 灰
        {c1: '#2692FE', c2: '#0079F2'}, // 蓝
        {c1: '#FFAC05', c2: '#FF6600'}, // 黄
      ]

      // 初审
      if (key == "primaryAudit_Pie") {
        if (this.audit[1].flag == 2) {
          colorList = [
            {c1: '#2692FE', c2: '#0079F2'}, // 蓝
            {c1: '#FFAC05', c2: '#FF6600'}, // 黄
          ]
        }
      
      // 终审
      } else if (key == "endAudit_Pie") {
        if (this.audit[2].flag == 2) {
          colorList = [
            {c1: '#2692FE', c2: '#0079F2'}, // 蓝
            {c1: '#FFAC05', c2: '#FF6600'}, // 黄
          ]
        }

      // 缴费
      } else if (key == "Pay_Pie" || key == "Chart_Exam_A") {
        colorList = [
          {c1: '#2692FE', c2: '#0079F2'}, // 蓝
          {c1: '#FFAC05', c2: '#FF6600'}, // 黄
          {c1: '#EBEDF2', c2: '#EBEDF2'}, // 灰
        ]

      // 准考证 || 阅卷
      } else if (key == "Entrance_Pie" || key == "marking_Pie") {
        colorList = [
          {c1: '#2692FE', c2: '#0079F2'}, // 蓝
          {c1: '#EBEDF2', c2: '#EBEDF2'}, // 灰
        ]

      // 考试
      } else if (key == "Chart_Exam_B") {
        colorList = [
          {c1: '#2692FE', c2: '#0079F2'}, // 蓝
          {c1: '#FFAC05', c2: '#FF6600'}, // 黄
        ]
      } 

      let unit = "人";
      if (key == "marking_Pie") {
        unit = "份";
      }

      document.getElementById(key).removeAttribute('_echarts_instance_')
      let myChart = this.$echarts.init(document.getElementById(key))
      var option = {
        legend: {
          top: '5%',
          left: 'center',
          itemGap: 32,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 14,
            lineHeight: 20,
            color: '#737780',
          },
          formatter: function(name) {
            let newName = '';
            for (let i = 0; i < data.length; i++) {
              if (data[i].name == name) {
                newName = name + "：" + data[i].value + "  " + unit;
              }
            }
            return newName;
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '60%'],   // 饼图的位置
            radius: isRadius ? ['40%', '60%']: ['0%', '60%'], // 饼图的半径
            label: {
              normal: {
                show: true,
                fontSize: 12,
                color: "#45494D",
                position: label ? 'center': 'outside',
                lineHeight: 20,
                formatter: function(params) {
                  if (isShowLine) {
                    return params.name + "   " + params.percent + ' %';
                  } else if (label){
                    return label + '\n'
                  } else {
                    return ''
                  }
                },
                
              },
            },
            itemStyle: {
              normal: {
                color: function(params) {
                  return {
                    type: 'linear',
                    colorStops: [
                      { offset: 0, color: colorList[params.dataIndex].c1},
                      { offset: 1, color: colorList[params.dataIndex].c2},
                    ]
                  }
                }
              }
            },
            labelLine: {
              show: isShowLine,
              normal: {
                length: 15,
                length2: 30,
                lineStyle: {
                  color: "#DADDE5"
                },
              }
            },
            data: data
          }
        ]
      };

      option && myChart.setOption(option);
    },

    /**********************************************
     * @param { E-charts Bar }
     **********************************************/
    set_Chart_Bar(id, data_x, data_y) {
      this.$nextTick(()=>{
        document.getElementById(id).removeAttribute('_echarts_instance_')
        let myChart = this.$echarts.init(document.getElementById(id));
        let data = data_y;
        let dataAxis = data_x;
        let option = {
          grid: {
            x: 48,
            x2: 48,
            y2: 36,
          },
          xAxis: {
            data: dataAxis,
          },
          yAxis: {
            name: "单位：人次",
            type: 'value',
            nameTextStyle: {
              color: "#9299A6",
              fontFamily: "PingFangSC-Regular, PingFang SC",
              padding: [0, 0, 16, 0]
            },
          },
          series: [
            {
              type: 'bar',
              barWidth: 24,
              borderRadius: 2,
              barMinHeight: 2,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    position: 'top',
                    fontSize: 12,
                    color: "#636871",
                    fontFamily: "PingFangSC-Regular, PingFang SC",
                  },
                  color: {
                    type: 'linear',
                    x: 0, y: 0, x2: 0, y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: '#2692FE'
                      },
                      {
                        offset: 1,
                        color: "#0079F2"
                      }
                    ]
                  }
                },
              },
              data: data
            }
          ]
        }

        myChart.setOption(option, true);
      })
  

    },

    /**********************************************
     * @param { 自动打开折叠面板 }
     **********************************************/
    openStep() {
      this.$nextTick(() => {
        this.activeNames = [];
        if (!this.isOpenFlag) {
          this.activeNames = [];
        } else {
          this.audit.map( (e, i) => {
            if (e.flag == 1 && e.show) {
              this.activeNames.push(i);
            }
          })          
        }
      })
    },

    /**********************************************
     * @param { 滚动自动定位 }
     **********************************************/
    setScrollTarget() {
      this.$nextTick(() => {
        if (this.activeNames.length > 0) {
          let el = document.getElementById(`step_${this.activeNames[0]}`);
          // let el = document.getElementById(`Intelligent_management`);
          let IndexDOM = document.getElementById('Index');
          IndexDOM.scrollTo(0, el.offsetTop - 126);
          // el.scrollIntoView(true);
          setTimeout(() => {
            let mainDom = document.getElementById("Main");
            mainDom.style.height = "auto";
          }, 1000);
        }
      })
    },

    /**********************************************
     * @param { 跳转 }
     * 1=>跳转初审 
     * 2=>跳转终审 
     * 3=>到期提示弹窗
     **********************************************/
    jumpAudit(flag) {
      if (flag == 3) {
        this.BeComing_Dialog = true;
        return;
      }
      let query = { planId: this.currentPlan.id }
      if (flag == 1 && isHasRoute("applyFirst", this.routes)) {
        this.$router.push({ name: "applyFirst", query });
      } else {
        this.$router.push({ name: "applyAudit", query });
      }
    },

    /**********************************************
     * @param { 跳转公告 }
     **********************************************/
    jumpNotice() {
      if (this.noticeShow) {
        this.noticeDialog = true;
      }
    },

    /**********************************************
     * @param { 跳转考试报告 }
     **********************************************/
    jumpExportPDF() {
      this.$router.push({ name: "examReportPDF", query: { planId: this.currentPlan.id } });
    },
    
    /**********************************************
     * @param { 获取公告（列表） }
     **********************************************/
    async getNotice() {
      let params = {
        isFrom: "00",
      }
      let { data } = await selectNoticeListInfo(params);
      let notice = data[0];
      this.noticeShow = notice ? true: false;
      if (!notice) return;
      notice.releaseTime = notice.releaseTime.replace('T',' ').slice(0, 10);
      this.notice = notice;
    },

    /**********************************************
     * @param { 获取公告（弹一次） }
     **********************************************/
    async getNoticeOnce() { 
      const { data } = await selectNoticeListInfo({ isFrom: "01" });
      if (data.length > 0 && data[0].noticeShow != "0") {
        this.noticeOnceDialog = true;
        this.alertInfo = data[0];
        let par = {
          id: data[0].id,
          isFrom: "00",
        };
        selectNoticeByIdInfo(par);
      } 
    },
    getCustomWelcome(){
      let params = {tenantCode: window.localStorage.getItem('tenant')}

      this.$api.system.getCustom(params).then(res=>{
        this.welcomeMsgFlag = res.data.welcomeMsgFlag;
        this.welcomeContent = res.data.welcomeContent;
      })
    }
  }
}
</script>

<style scoped lang="less">
// 不可选
.notSelect {
  user-select: none;
}

/deep/ .el-dialog__footer {
  text-align: center;
}

.needOIS {
  margin: 0 auto;
}

// 公告
.noticeDialog {
  p {
    color: #45494D; 
    font-size: 24px; 
    font-family: 'PingFangSC-Medium, PingFang SC'; 
    width: 60%; 
    margin: 0 auto; 
    text-align: center; 
  }
  div {
    line-height: 24px;
  }
}

/deep/ .el-dialog{
  border-radius: 8px;
  min-width: 720px;
  max-height: 72vh;
  overflow: auto;
}


.Notice {
  margin-bottom: 24px;
  border-radius: 4px; border: 1px solid #f8c331;
  box-sizing: border-box;
  .importantNote {
    width: 100%; height: 20px; margin-top: -7px;
    font-size: 14px; color: #ff9500;
    display: flex; align-items: center;
    img {
      width: 20px; height: 20px; margin-top: 2px; margin-right: 16px;
    }
  }
}

// 选择批次
.Plan {
  height: 32px; margin-bottom: 20px;
  p {
    display: flex; align-items: center;
    font-family: "PingFangSC-Regular, PingFang SC";
    &>span {
      font-size: 24px; font-weight: 500; color: #2d2f33;
    }
    .el-dropdown-link {
      width: 52px; height: 24px; margin-left: 8px; padding-left: 8px;
      font-size: 13px; color: var(--el-color-primary);
      border-radius: 12px; border: 1px solid #E1E6ED; box-sizing: border-box;
      display: flex; align-items: center;
      cursor: pointer;
      span {
        color: #006AFF;
      }
      i {
        font-size: 8px; margin-left: 2px; color: #006AFF;
      }
    }
  }
}

// Main
.Main {
  width: 100%; height: auto;
  &>div{
    width: 100%; height: auto; margin-top: 32px; font-family: "PingFangSC-Regular, PingFang SC";
    .title {
      width: 100%; height: 24px; box-sizing: border-box; margin-bottom: 16px; color: #2D2F33;
      display: flex; align-items: center;
      user-select: none; 
      &>div {
        width: 5px; height: 16px; border-radius: 2.5px; margin-right: 6px;
        background-color: #006AFF;
      }
    }
    .Step {
      margin-top: 72px;
    }
    .titleCard {
      user-select: none;
      display: flex; justify-content: space-between;
      color: #737780;
      .titleCardItem.titleCardItemWidth_25 {
        width: 25%;
      }
      .titleCardItem.titleCardItemWidth_33 {
        width: 33%;
      }
      .titleCardItem {
        max-height: 105px; background-size: 100% 100%; box-shadow: 0px 6px 24px 0px rgba(0, 69, 166, 0.15); border-radius: 8px;
        padding: 20px 30px 20px 24px;  margin-right: 16px;
        box-sizing: border-box;
        transition: all .5s;
        & > div {
          width: 100%; height: auto; position: relative;
          .icon {
            width: 40px; height: 40px;
            position: absolute; right: 0; top: 50%;
            transform: translateY(-50%);
          }
          h3 {
            font-size: 14px; height: 19px; margin-bottom: 5px;
            span {
              font-size: 14px; margin-right: 4px;
            }
            h2 {
              display: inline-block; margin-left: 8px;
            }
          }
          .examNumCard {
            font-size: 20px; display: block; line-height: 47px; margin: 0 16px;
          }
          span {
            font-size: 32px;
          }
          .time {
            p {
              margin-top: 4px; font-size: 13px; line-height: 16px; position: relative; z-index: 1;
              span {
                font-size: 13px;
              }
            }
            p:last-of-type {
              margin-top: 8px;
            }
          }
        }
      }
      .titleCardItem:nth-of-type(4) {
        margin-right: 0;
      }
      .titleCardItem:nth-child(1) {
        background: #FCF8F1;
        .icon {
          background-image: url("../assets/img/icon-001.png");
        }
      }
      .titleCardItem:nth-child(2) {
        background: #F5FDF8;
        .icon {
          background-image: url("../assets/img/icon-002.png");
        }
      }
      .titleCardItem:nth-child(3) {
        background: #F1F8FE;
        .icon {
          background-image: url("../assets/img/icon-003.png");
        }
      }
      .titleCardItem:nth-child(4) {
        background: #F5F1FD;
        .icon {
          background-image: url("../assets/img/icon-004.png");
        }
      }
    }
    @media screen and (max-width: 1366px) {
      .titleCard {
        flex-wrap: wrap;
        .titleCardItem.titleCardItem.titleCardItemWidth_25,
        .titleCardItem.titleCardItem.titleCardItemWidth_33 {
          width: 49%;
          height: 124px;
          & > div {
            .time {
              display: flex;
              justify-content: space-between;
              p:first-of-type {
                margin-right: 16px;
              }
              p:last-of-type {
                margin-top: 4px;
              }
            }
          }
        }
        .titleCardItem:nth-of-type(4),
        .titleCardItem:nth-of-type(2) {
          margin-right: 0;
        }
        .titleCardItem:nth-of-type(1),
        .titleCardItem:nth-of-type(3) {
          margin-right: 0px;
        }
        .titleCardItem:nth-of-type(3),
        .titleCardItem:nth-of-type(4) {
          margin-top: 20px;
        }
      }
    }
    .message {
      margin-top: 16px; padding: 22px 24px; box-sizing: border-box; background: #FFF; border-radius: 6px;
      &>p {
        display: inline-block; margin-right: 72px; font-size: 14px; color: #45494D; font-weight: 500;
        .yellow {
          color: #F27900;
        }
        .blue {
          color: #006AFF;
          cursor: pointer;
        }
      }
      &>p::before {
        content: "";
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #FE5958;
        margin-right: 5px;
        margin-bottom: 2px;
      }
    }
  }
}

.el-steps {
  font-family: "PingFangSC-Medium, PingFang SC";
  .el-step {
    /deep/ .el-step__head {
      display: flex; justify-content: center;
      .el-step__icon {
        width: 10px; height: 10px; border-width: 3px; box-sizing: border-box; border-color: #dadde6;
        .el-step__icon-inner {
          display: none;
        }
      }
      .el-step__line {
        background: #f1f2f5;
      }
    }
    /deep/ .el-step__head.is-finish {
      .el-step__icon {
        border-color: #0b66e6;
      }
    }
    // 步骤条内容
    /deep/ .el-step__main {
      // border: 1px solid red;
      // min-height: 40px; 
      margin-left: 8px; margin-top: -40px; margin-bottom: calc(40px + 16px); padding: 16px 24px;
      border-radius: 8px; box-sizing: border-box;
      display: flex; align-items: center;
      background: #FFF;
      .el-step__description {
        width: 100%; padding: 0; margin: 0;
        float: left; 
        .showBtn {
          float: right; margin-top: 16px; font-size: 14px;
          color: #006AFF;
          cursor: pointer;
        }
        .des {
          float: left;
          width: calc(100% - 82px);
          .des-title {
            display: flex; align-items: center;
            .state {
              .dit {
                display: inline-block; border-radius: 50%;
                width: 6px; height: 6px;
                margin-bottom: 2px; margin-right: 4px;
                background: #ADB3BF;
              }
              display: inline-block;
              width: 64px; height: 22px; line-height: 22px; border-radius: 3px; margin-right: 8px;
              text-align: center; font-size: 14px;
              color: #ADB3BF;
              background: #E1E5ED;
            }
            .name {
              font-size: 18px; font-weight: 500;
              color: #9299A6;
            }
          }
          .des-data {
            width: auto;
            // width: 420px;
            max-width: 560px;
            margin-top: 8px; font-size: 14px;
            color: #9299A6;
          }
        }

        .notOpenFlag {
          width: 100%;
          display: flex; 
          align-items: center; 
          justify-content: space-between;
        }

        .content {
          transition: all .5s;
          float: left;
          width: 100%;
          display: block;
        }
      }
    }
  }

  .el-step.start {
    /deep/ .el-step__main {
      background: linear-gradient(90deg, rgba(228, 250, 255, 0.4961) 6%, #E0EDFF 96%), #FFFFFF;
      .el-step__description {
        .des {
          .des-title {
            .state {
              .dit {
                background: #1DBF60;
              }
              background: #DFFFEF;
              color: #1DBF60;
            }
            .name {
              color: #2E3033;
            }
          }
          .des-data {
            color: #737780;
          }
        }
      }
    }
  }

  .el-step.over {
    /deep/ .el-step__main {
      .el-step__description {
        .des {
          .des-title {
            .state {
              .dit {
                background: #567CB0;
              }
              background: #D9E9FF;
              color: #567CB0;
            }
            .name {
              color: #2E3033;
            }
          }
          .des-data {
            color: #737780;
          }
        }
      }
    }
  }
}

// 折叠面板
.el-collapse {
  border: 1px dashed transparent; box-sizing: border-box;
  /deep/ .el-collapse-item__header {
    border: 1px dashed transparent; box-sizing: border-box; font-size: 14px;
    color: #C2C6CC; background: transparent;
  }
  /deep/ .el-collapse-item__wrap {
    width: calc(100% + 48px);
    margin-left: -24px; margin-top: 16px; margin-bottom: -16px; box-sizing: border-box; border: 1px dashed transparent;
    // background: #FAFBFD;
    background: #FFF;
    // Step
    .StepInfo {
      width: 100%; height: 480px; border-radius: 6px; padding-top: 24px; box-sizing: border-box;

      .Sign {
        width: 100%; height: 100%; display: flex;
        .info {
          width: 396px; height: 100%; box-sizing: border-box; padding-left: 48px;
          .title {
            width: auto; margin-bottom: 48px;
            font-size: 16px; font-weight: 500;
            color: #45494D;
          }
          .sign_number {
            width: 100%; height: auto;
            .mobile_sign,.pc_sign {
              &>span {
                color: #45494D; font-size: 14px;
              }
              .number{
                margin-top: 16px; display: flex; padding-right: 84px; box-sizing: border-box; justify-content: space-between;
                &>div {
                  &>div:first-child {
                    color: #737780; font-size: 14px;
                  }
                  &>div:last-child {
                    color: #45494D; font-size: 26px; font-weight: 700;
                  }
                }
              }
            }
            .pc_sign {
              margin-top: 40px;
            }
          }
        }
        .charts {
          font-family: "PingFangSC-Medium, PingFang SC";
          width: calc(100% - 396px); height: 100%; box-sizing: border-box;
          .title {
            width: auto; font-size: 16px; font-weight: 500; margin-bottom: 0;
            color: #45494D;
          }
        }
      }
      
      .primaryAudit {
        width: 100%;
        height: 100%;
        display: flex;
        .left {
          width: 560px; height: 100%; box-sizing: border-box;
          .title {
            width: auto; color: #45494D; font-size: 16px; font-weight: 500; margin-bottom: 0; margin-top: 8px; margin-left: 48px;
          }
          .chartsAudit {
            width: 100%; height: 420px; box-sizing: border-box;
          }
        }
        .right {
          width: calc(100% - 560px); height: 100%; box-sizing: border-box;
          .title {
            width: 100%; color: #45494D; font-size: 16px; font-weight: 500; margin-bottom: 0; margin-top: 8px;
          }
          .rollItem {
            float: left;
            width: 50%; height: 360px; box-sizing: border-box; overflow: hidden; margin-top: 36px;
            border: 1px dashed red;
            .wrap {
              width: 100%; height: 100%; overflow: hidden;
            }



            /* ******************** */
            .payStudent {
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
            // 实时缴费滚动列表
            .payStudent li {
              display: flex;
              justify-content: space-between;
              height: 60px;
              line-height: 60px;
              border-bottom: 1px dashed #DADDE5;
              box-sizing: border-box;
              .user {
                width: 160px;
                display: flex;
                align-items: center;
                > img {
                  width: 40px;
                  height: 40px;
                  box-shadow: 0px 0px 4px 0px rgba(199, 205, 213, 0.59);
                  border-radius: 50%;
                }
                span {
                  display: inline-block;
                  margin-left: 8px;
                }
              }
              .payStatus {
                position: relative;
              }
              .payStatus::before {
                content: "";
                position: absolute;
                left: -10px;
                top: 27px;
                width: 5px;
                height: 5px;
                background-color: #00a652;
                border-radius: 50%;
              }
            }



            /* ************************** */
          }
        }
      }

      .Exam {
        .top {
          font-size: 16px;
          color: #45494D;
          text-align: center;
        }
        .main {
          width: 100%;
          height: 420px;
          box-sizing: border-box;
          display: flex;
          &>div {
            width: 50%;
            height: 420px;
          }

          .currentTitle {
            position: absolute; left: calc(50% - 58px); top: calc(50% + 12px); text-align: center; font-size: 16px; color: #45494D;
            display: flex;
            flex-wrap: wrap;
            width: 64px;
            height: 56px;
            align-items: center;
            p {
              width: 100%;
              text-align: center;
            }
          }

        }
      }

      .scoreCheck {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        .chooseCourse {
          position: absolute;
          right: 32px;
          top: 0;
        }
        .title {
          width: auto; height: 36px; box-sizing: border-box;
          margin-left: 48px; margin-bottom: 16px;
          font-size: 16px; font-weight: 500;
          color: #45494D;
        }
        .top {
          width: 100%;
          height: 50px;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          &>div {
            width: 100px; height: 100%;
            margin-right: 64px;
            text-align: center;
            span:first-child {
              font-size: 20px;
              line-height: 28px;
              color: #2D2F33;
            }
            span:nth-child(2) {
              font-size: 13px;
              color: #737780;
            }
            span:last-child {
              font-size: 14px;
              color: #737780;
            }
          }
        }
        .bottom {
          width: 100%;
          height: auto;
          padding-left: 48px;
          box-sizing: border-box;
          &>div {
            width: 100%;
            display: flex;
            align-items: center;
            margin-top: 20px;
            &>span {
              width: 62px; height: 20px; margin-right: 12px;
              display: inline-block;
              text-align: right;
              color: #808080;
            }
            &>div {
              width: calc(100% - 180px); height: 20px; display: inline-block;
              background: #F2F6FC;
              border-radius: 0px 2px 2px 0px;
              &>div {
                width: 40%;
                height: 100%;
                border-radius: 2px;
                
              }
            }
          }
        }
      }

    }

  }

}

.exportPDF {
  width: 100%;
  // margin-top: 24px;
  &>p {
    color: #737780;
    font-family: "PingFangSC-Medium, PingFang SC";
    text-align: center;
    &>span {
      color: #006AFF;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
  }
}

.start,.over {
  .el-collapse {
    /deep/ .el-collapse-item__header {
      color: #006AFF;
    }
  }
}

</style>